<template>
  <div class="locale-switcher">
    <select v-model="$i18n.locale">
      <option
        v-for="(lang, i) in langs" :key="`Lang${i}`"
        :value="lang">Language: {{ lang }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'locale-switcher',
  data() {
    return { langs: ['en', 'fr'] };
  },
};
</script>

<style scoped>
/* https://stackoverflow.com/questions/1895476/how-do-i-style-a-select-dropdown-with-only-css */
select {
    -webkit-appearance: button;
    -moz-appearance: button;
    -webkit-user-select: none;
    -moz-user-select: none;
    -webkit-padding-end: 20px;
    -moz-padding-end: 20px;
    -webkit-padding-start: 2px;
    -moz-padding-start: 2px;
    background-color: #ffffff; /* Fallback color if gradients are not supported */
    background-position: center right;
    background-repeat: no-repeat;
    border: 1px solid #AAA;
    border-radius: 2px;
    box-shadow: 0px 1px 3px rgba(204, 165, 165, 0.1);
    color: #555;
    font-size: inherit;
    margin: 0;
    overflow: hidden;
    padding-top: 2px;
    padding-bottom: 2px;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    width: 80%;
    height: 50px;
    padding: 10px;
    width: 100%;
}
</style>
